export const kpiRoutes = {
  Library: '/library',
  Templates: '/templates',
  CompanyStatus: '/company',
  DataEntryRoot: '/data-entry',
  DataEntry: '/data-entry/:id',
};
